// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_Bqp","cls2":"common-cls2_3jd common-cls1_Bqp"};